import React from 'react';

interface LogoProps {
  className?: string;
  width?: number;
}

export const Logo: React.FC<LogoProps> = ({ className = '', width = 150 }) => {
  return (
    <img 
      src="/assets/branding/logo-main.webp" 
      alt="Nossa Pesca Logo" 
      width={width}
      className={`object-contain ${className}`}
    />
  );
};
